import { render, staticRenderFns } from "./AddAccessory.vue?vue&type=template&id=1079e2e4"
import script from "./AddAccessory.vue?vue&type=script&lang=js"
export * from "./AddAccessory.vue?vue&type=script&lang=js"
import style0 from "./AddAccessory.vue?vue&type=style&index=0&id=1079e2e4&prod&lang=css"
import style1 from "./AddAccessory.vue?vue&type=style&index=1&id=1079e2e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports